import React, { useEffect, useState } from "react";

import { FiSearch } from "react-icons/fi";
import { MdOutlineCalendarMonth, MdOutlineLocationOn } from "react-icons/md";
import { IoCameraOutline } from "react-icons/io5";
import { BsThreeDots } from "react-icons/bs";
import { LuCamera } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function RamaEventData() {
  const [event, setEvent] = useState([]);
  //console.log("event", event);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <div>
      <aside className="mainSection">
        <div className="mb-5 pb-5 border-bottom">
          <div className="topEventFilter py-3 px-4">
            <div className="searchField">
              <button className="serchBtn">
                <FiSearch size={18} />
              </button>
              <input
                className="form-control"
                placeholder="Search name or address"
                type="text"
              />
            </div>
            <div className="formField">
              <span className="selectIcon">
                <MdOutlineLocationOn size={18} />
              </span>
              <select className="form-select">
                <option>Location</option>
                <option>Location1</option>
                <option>Location2</option>
              </select>
            </div>
            <div className="formField">
              <span className="selectIcon">
                <MdOutlineCalendarMonth size={17} />
              </span>
              <select className="form-select">
                <option>Sort By Date</option>
              </select>
            </div>
            <div className="formField">
              <span className="selectIcon">
                <IoCameraOutline size={18} />
              </span>
              <select className="form-select">
                <option>Camera</option>
              </select>
            </div>
          </div>

          <div className="p-4">
            {/* <div className="d-flex justify-content-between align-items-center">
              <h3 className="m-0 font24">
                All Events ({event?.length === 0 ? 4 : ""})
              </h3>

              <div className="d-flex align-items-center gap-3">
                <button className="transParent3 p-2">Select</button>
                <button
                  onClick={() => navigate("/create-new-event")}
                  className="mainBlue3 p-2"
                >
                  + New Event
                </button>
              </div>
            </div> */}
          </div>

          <div className="px-4">
            <div className="allEventsItems">
              <div
                className="itemsBox"
                onMouseDown={(e) => {
                  e.currentTarget.setAttribute("data-down", "true");
                }}
                onMouseUp={(e) => {
                  // Only navigate if mouse was clicked, not dragged
                  const wasDown = e.currentTarget.getAttribute("data-down");
                  if (
                    wasDown === "true" &&
                    window.getSelection().toString().length === 0
                  ) {
                    navigate("/rama-mess-logs-dashboard");
                  }
                  e.currentTarget.removeAttribute("data-down");
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="ident">Mess Detection </span>
                  <BsThreeDots size={28} />
                </div>
                <h3 className="my-3">Rama Mess</h3>
                <p className="contIcon mb-2">
                  <span className="selectIcon">
                    <MdOutlineCalendarMonth size={18} />
                  </span>{" "}
                  Jul 25 - Aug 25
                </p>
                <p className="contIcon">
                  <span className="selectIcon">
                    <LuCamera size={18} />
                  </span>
                  Rama Mess
                </p>
              </div>

              <div
                className="itemsBox"
                onMouseDown={(e) => {
                  e.currentTarget.setAttribute("data-down", "true");
                }}
                onMouseUp={(e) => {
                  // Only navigate if mouse was clicked, not dragged
                  const wasDown = e.currentTarget.getAttribute("data-down");
                  if (
                    wasDown === "true" &&
                    window.getSelection().toString().length === 0
                  ) {
                    navigate("/rama-logs-dashboard");
                  }
                  e.currentTarget.removeAttribute("data-down");
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="ident">Checkin-Checkout Monitoring </span>
                  <BsThreeDots size={28} />
                </div>
                <h3 className="my-3">Rama Checkin-CheckOut</h3>
                <p className="contIcon mb-2">
                  <span className="selectIcon">
                    <MdOutlineCalendarMonth size={18} />
                  </span>{" "}
                  Jul 25 - Aug 25
                </p>
                <p className="contIcon">
                  <span className="selectIcon">
                    <LuCamera size={18} />
                  </span>
                  Rama CheckIn-CheckOut
                </p>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default RamaEventData;
